module.exports = __webpack_public_path__ + "img/sup_wallet_banner.3de8cc97.jpg";